import { USER_WORKER_URL } from '../config.js';

/**
 * @param {{ token: string|null|undefined }} options
 * @returns {Promise<string|null>}
 */
export const fetchUserCreatedAt = async ({ token }) => {
  if (!token) return null;

  try {
    const response = await fetch(`${USER_WORKER_URL}/profile`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) return null;

    const profile = await response.json();
    if (!profile || typeof profile !== 'object') return null;
    return profile.created_at || null;
  } catch (error) {
    console.warn('[UserProfileApi] Failed to fetch user profile:', error);
    return null;
  }
};
